import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const requiredEnv = (key) => {
  const value = process.env[key];

  if (!value) {
    console.error(`Missing environment variable: ${key}`);
    return "";
  }

  return value;
};

export const functionsBaseUrl =
  process.env.REACT_APP_FUNCTIONS_BASE_URL ||
  "https://europe-west2-architectureapp-9e70d.cloudfunctions.net";

export const signupConfig = {
  termsVersion: process.env.REACT_APP_TERMS_VERSION || "v1.0",
  successUrl: process.env.REACT_APP_SIGNUP_SUCCESS_URL || "",
  cancelUrl: process.env.REACT_APP_SIGNUP_CANCEL_URL || "",
  processingUrl: process.env.REACT_APP_SIGNUP_PROCESSING_URL || "",
};

const firebaseConfig = {
  apiKey: requiredEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: requiredEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "architectureapp-9e70d",
  storageBucket: requiredEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: requiredEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: requiredEnv("REACT_APP_FIREBASE_APP_ID"),
};

// console.log("Firebase config loaded:", {
//   projectId: firebaseConfig.projectId,
//   authDomain: firebaseConfig.authDomain,
//   hasApiKey: Boolean(firebaseConfig.apiKey),
//   hasAppId: Boolean(firebaseConfig.appId),
// });

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "europe-west2");
const storage = getStorage(app);

export { auth, db, functions, storage };